// ** Custom Components
import Avatar from '@components/avatar'
import { Fragment, useEffect, useState } from 'react'
import axios from '@src/configs/axios/axiosConfig'
import { Input } from 'reactstrap'
const profileImg = require('@src/assets/images/avatars/avatar-blank.png').default
const ProfileImage = ({ fileId, imgWidth, imgHeight, uploadFlag, className = '' }) => {

  const [fileData, setFileData] = useState(null)
  const [fileid, setFileid] = useState(null)

  const getFileData = () => {
    if (fileid) {
      axios.post('/files/getFileData', { id: fileid }).then((res) => {
        setFileData(res.data.filedata)
      }).catch((err) => { console.log(err) })
    }
  }

  useEffect(() => {
    if (fileId !== '' && fileId) {
      setFileid(fileId)
    }
  }, [fileId])

  useEffect(() => {
    getFileData()
  }, [fileid])

  const updateId = (attachementId, id) => {

    axios.post('/organizations/updatelogo', { attachementId, id }).then(() => {
      toast.success('Organization Picture Uploaded Successfully', { position: "bottom-right" })
      setImageId(attachementId)
      setBlock(false)
    }).catch((err) => { console.log(err) })

  }

  const uploadFiles = (file) => {

    const formData = new FormData()
    formData.append(`files[0]`, file)
    formData.append('organizationId', activeOrgId)
    formData.append('createdBy', userId)
    const filePath = [activeOrg?.name, 'Logo']
    filePath.forEach((file, key) => {
      formData.append(`folderPath[${key}]`, file)
    })
    setBlock(true)
    axios.post('/files/upload', formData).then((res) => {
      updateId(res?.data?.attachment_ids[0], activeOrgId)
    }).catch((err) => { console.log(err) })
  }

  const onChange = e => {
    const reader = new FileReader(),
      files = e.target.files
    reader.readAsDataURL(files[0])

    uploadFiles(e.target.files[0])

  }


  return (
    <Fragment>
      {uploadFlag &&
        <Fragment>
          {!fileData ? <Avatar imgHeight={imgHeight} imgWidth={imgWidth} color='light-danger' img={profileImg} ><Input type='file' onChange={onChange} hidden accept='image/*' /></Avatar> : <Avatar imgHeight={imgHeight} imgWidth={imgWidth} img={fileData} ><Input type='file' onChange={onChange} hidden accept='image/*' /></Avatar>}
        </Fragment>
      }
      {!uploadFlag &&
        <Fragment>
          {!fileData ? <Avatar imgHeight={imgHeight} imgWidth={imgWidth} color='light-danger' img={profileImg} className={className} /> : <Avatar imgHeight={imgHeight} imgWidth={imgWidth} img={fileData} className={className} />}
        </Fragment>

      }
    </Fragment>
  )
}
export default ProfileImage
